import React from 'react';
import {
  Star,
  CheckCircle2,
  Sparkles,
  Shield,
  Zap,
  Globe,
  Calculator,
  Workflow,
  Code,
  ChartNoAxesCombined,
  FileText,
  Layers,
  Terminal,
  Cpu,
  TrendingUp,
  Download
} from 'lucide-react';

export function ToolVisualCard({ tool, details, size = 'large' }) {
  const isCompact = size === 'compact';
  const category = tool.category || 'website';
  const metrics = details?.previewMetrics || [
    { label: 'Input Mode', val: 'Real-time' },
    { label: 'Execution', val: 'Local Browser' },
    { label: 'Status', val: 'Enter inputs in the workspace', highlight: true }
  ];

  return (
    <div className={`tool-visual-mockup-card ${category}-theme ${isCompact ? 'compact' : ''}`}>
      {/* Mockup Browser Topbar */}
      <div className="mockup-window-header">
        <div className="window-dots">
          <span className="dot red"></span>
          <span className="dot yellow"></span>
          <span className="dot green"></span>
        </div>
        <div className="window-address-bar">
          <Shield size={12} className="ssl-icon" />
          <span>bizaipro.com{tool.path || `/tools/${tool.slug}/`}</span>
        </div>
        <div className="window-badge">
          <Sparkles size={12} />
          <span>PRO</span>
        </div>
      </div>

      {/* Mockup Canvas */}
      <div className="mockup-canvas">
        <div className="canvas-glow"></div>

        <div className="canvas-header-row">
          <div className="canvas-badge-pill">
            <span className="live-pulse"></span>
            <span>{details?.badge || 'Live Business Utility'}</span>
          </div>
          <div className="canvas-rating-pill">
            <span>Illustrative preview</span>
          </div>
        </div>

        <div className="canvas-main-title">
          <h3>{tool.name}</h3>
          <p>{tool.description}</p>
        </div>

        {/* Visual Simulated Output Tiles */}
        <div className="canvas-metrics-grid">
          {metrics.map((m, i) => (
            <div key={i} className={`metric-tile ${m.highlight ? 'highlighted' : ''}`}>
              <span className="tile-label">{m.label}</span>
              <strong className="tile-val">{m.val}</strong>
            </div>
          ))}
        </div>

        {/* Feature Pills */}
        <div className="canvas-footer-tags">
          <span><CheckCircle2 size={13} /> Free to use</span>
          <span><Zap size={13} /> Use the workspace above</span>
          <span><Shield size={13} /> {tool.processing}</span>
        </div>
      </div>
    </div>
  );
}

export function AssetVisualCard({ asset, size = 'large' }) {
  const isCompact = size === 'compact';
  const category = asset.category || 'wordpress';

  return (
    <div className={`tool-visual-mockup-card asset-theme ${category}-theme ${isCompact ? 'compact' : ''}`}>
      <div className="mockup-window-header">
        <div className="window-dots">
          <span className="dot red"></span>
          <span className="dot yellow"></span>
          <span className="dot green"></span>
        </div>
        <div className="window-address-bar">
          <span>vault.bizaipro.com/downloads/{asset.slug}.zip</span>
        </div>
        <div className="window-badge green">
          <Download size={12} />
          <span>FREE</span>
        </div>
      </div>

      <div className="mockup-canvas">
        <div className="canvas-glow"></div>

        <div className="canvas-header-row">
          <div className="canvas-badge-pill">
            <span className="live-pulse"></span>
            <span>{asset.subcategory}</span>
          </div>
          <div className="canvas-rating-pill">
            <Star size={13} fill="#f59e0b" color="#f59e0b" />
            <span>{asset.rating}</span>
            <span className="user-count">({asset.downloads.toLocaleString()} dl)</span>
          </div>
        </div>

        <div className="canvas-main-title">
          <h3>{asset.title}</h3>
          <p>{asset.summary}</p>
        </div>

        <div className="canvas-metrics-grid">
          <div className="metric-tile">
            <span className="tile-label">Format</span>
            <strong className="tile-val">{asset.format || 'ZIP / Source'}</strong>
          </div>
          <div className="metric-tile">
            <span className="tile-label">Version</span>
            <strong className="tile-val">v{asset.version}</strong>
          </div>
          <div className="metric-tile highlighted">
            <span className="tile-label">Package Size</span>
            <strong className="tile-val">{asset.fileSize}</strong>
          </div>
        </div>

        <div className="canvas-footer-tags">
          <span><CheckCircle2 size={13} /> Full Source Code</span>
          <span><Shield size={13} /> Commercial License</span>
          <span><Zap size={13} /> Instant Direct Unlock</span>
        </div>
      </div>
    </div>
  );
}
